import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import './SearchBar.css';
import Loader from './Loader/Loader'; 
const SearchBar = () => {
    // Get the search query from the URL parameters
  const { query } = useParams(); 
  // State to store search results
  const [searchResults, setSearchResults] = useState([]); 
  // State to manage loading state
  const [isLoading, setIsLoading] = useState(true); 

  useEffect(() => {
    // Fetch search results from the API
    const fetchSearchResults = async () => {
      const apiKey = process.env.REACT_APP_TMDB_API_KEY;
      try {
        const response = await fetch(
          `https://api.themoviedb.org/3/search/movie?api_key=${apiKey}&query=${query}`
        );
        const data = await response.json();
        // Update state with fetched search results
        setSearchResults(data.results); 
      } catch (error) {
        console.error('Error fetching search results:', error);
      } finally {
        // Set loading state to false when fetch is complete
        setIsLoading(false); 
      }
    };

    fetchSearchResults();
    // The effect depends on the search query
  }, [query]); 

  // Display loader while fetching data
  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className="search-results-container">
      <h2 className="search-results-heading">Search Results for "{query}"</h2>
      <div className="movie-grid">
        {searchResults.map((movie) => (
          <div key={movie.id} className="movie-item movie-box">
            <Link to={`/movies/${movie.id}`} className="movie-link">
              <img
                src={`https://image.tmdb.org/t/p/w300${movie.poster_path}`}
                alt={movie.title}
                className="movie-poster"
              />
              <div className="movie-title movie-box">{movie.title}</div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SearchBar;
